import { t } from "i18next";
import React from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import BannerImages from "../../Common/BannerImages";
import Banner from "../../Website/shopPage/Banner";
import LanguageTable from "../../Common/LanguageTable";
import { templateActions } from "../../templateStore";
import { templateDefaultValue } from "@constants/template";
import { useSelector } from "react-redux";

export function WebsitePayment({ selectedRows }: any) {
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [isReady, setIsReady] = React.useState(false);
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const boutique = schema + "_" + selectedRows[0].shopId;
    const [activeTab, setActiveTab] = React.useState<number>(0);

    const paymentImagePathDesktop = React.useMemo(
        () => ["SiteWeb", "Payment", boutique, "Header", "Image", "Desktop"],
        [boutique]
    );
    const paymentImagePathMobile = React.useMemo(
        () => ["SiteWeb", "Payment", boutique, "Header", "Image", "Mobile"],
        [boutique]
    );
    React.useEffect(() => {
        const ensureAllPaths = async () => {
            await templateActions.ensurePathExists(
                ["SiteWeb", "Payment", boutique, "Header", "Image", "Desktop"],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            await templateActions.ensurePathExists(
                ["SiteWeb", "Payment", boutique, "Header", "Image", "Mobile"],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            await templateActions.ensurePathExists(
                ["SiteWeb", "Payment", boutique, "Header", "Title"],
                templateDefaultValue.SiteWeb.Payment.Default.Header.Title
            );

            setIsReady(true);
        };

        ensureAllPaths();
    }, [boutique]);

    if (!isReady) return null;
    const tabs = [
        {
            title: t("Payment"),
            content: (
                <div className="banner-container mt-2">
                    <Banner
                        showTitle={true}
                        showDescription={false}
                        showSearch={false}
                        imagePath={[
                            "SiteWeb",
                            "Payment",
                            boutique,
                            "Header",
                            "Image",
                        ]}
                    />
                    <section className="text-section">
                        <p className="image-title">{t("Image banner")}</p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={paymentImagePathDesktop}
                                title="Image Desktop"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={paymentImagePathMobile}
                                title="Image Mobile"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={["SiteWeb", "Payment", boutique, "Header"]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Titre",
                                    placeholder: "Enter the Title",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.SiteWeb.Payment.Default
                                    .Header
                            }
                            sectionTitle="Title"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];
    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div style={{ width: "100%" }}>
            <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                <Nav
                    tabs
                    style={{
                        backgroundColor: "white",
                        width: "50px",
                        display: "grid",
                        gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                        border: "unset",
                    }}
                >
                    {tabs.map((element, index) => (
                        <NavItem
                            key={index}
                            className={classNames(
                                "pb-1",
                                "d-flex align-items-center text-nowrap",
                                {
                                    "disable-nav-item__clz":
                                        activeTab !== index,
                                },
                                element.customClassName
                            )}
                            style={{
                                cursor: "pointer",
                                borderBottom:
                                    activeTab === index
                                        ? `${mainColor} 3px solid`
                                        : "",
                            }}
                        >
                            <NavLink
                                className={classNames("text-dark w-100", {
                                    "active customer-account-menu-nav-link-active__clz":
                                        activeTab === index,
                                    "customer-account-menu-nav-link-disable__clz":
                                        activeTab !== index,
                                })}
                                onClick={() => toggleNav(index)}
                            >
                                <span
                                    className="px-2"
                                    style={{
                                        font:
                                            "normal normal 600 20px/27px Segoe UI",
                                    }}
                                >
                                    {element.title}
                                </span>
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </div>
            <TabContent activeTab={activeTab} className="h-100">
                {tabs.map((element, index) => (
                    <TabPane
                        tabId={index}
                        key={index}
                        style={{ height: "90%" }}
                    >
                        {element.content}
                    </TabPane>
                ))}
            </TabContent>
        </div>
    );
}
